import { setCookie, getCookie } from './helpers/cookies';

window.getCookie = getCookie;
window.setCookie = setCookie;

window.getCachedValue = function (t: string): string | null {
  try {
    const r = (localStorage && localStorage.getItem(t)) || getCookie(t) || null;
    if (r) {
      try {
        return JSON.parse(r);
      } catch (e) {
        // JSON parse failed, return raw value
      }
    }

    return r;
  } catch (n) {
    console.log(n);

    return null;
  }
};
